import { AccountCreatedProperties } from "@chef/events";
import { getPriceOfProductByVariation } from "@chef/state-management/helpers";
import { useAppSelector } from "@chef/state-management/hooks";

import { useSelectedProductAndVariationDetails } from "./useSelectedProductAndVariationDetails";
import { useSignupSession } from "./useSignupSession";

export const useTrackingData = (): {
  coupon?: string;
  discount?: number;
  campaign_id?: string;
  products: AccountCreatedProperties["products"]; // It is assumed that all product entries look the same
} => {
  const { signupSession } = useSignupSession();

  const { selectedProduct, selectedVariation } =
    useSelectedProductAndVariationDetails(signupSession);

  const variationPrice =
    (selectedVariation && getPriceOfProductByVariation(selectedVariation)) || 0;

  const discountCoupon = useAppSelector((state) => state.signupRtk.coupon);

  return {
    campaign_id: discountCoupon?.discountId,
    coupon: discountCoupon?.couponCode,
    discount: discountCoupon?.amount,
    products: [
      {
        variant_id: selectedVariation?.variationId || "",
        category_id: selectedProduct?.productTypeId || "",
        price: variationPrice,
        product_id: selectedProduct?.productId || "",
        quantity: 1,
      },
    ],
  };
};
